import { PublicSharingState } from 'SharingApp/ts/enums/public-sharing-state.enum';
export const VIEW = 'view';
export const EDIT = 'edit';
export const NO_VIEW = 'no_view';
export const OWNER_NO_ACCESS_ERROR = 'owner_no_access';
export const MISMATCHED_SHARED_ITEM_ERROR = 'mismatched_shared_item';
export const SHARE_ACCESS_ERRORS = [OWNER_NO_ACCESS_ERROR, MISMATCHED_SHARED_ITEM_ERROR];
export const PUBLIC_SHARING_STATE_LABEL = {
    [PublicSharingState.MARKED_FOR_SHARING]: 'Cancel request to publish',
    [PublicSharingState.SHARED]: 'Unpublish from public',
    [PublicSharingState.MARKED_FOR_UNSHARING]: 'Cancel request to unpublish',
    [PublicSharingState.NOT_SHARED]: 'Share',
    [PublicSharingState.APPROVED_FOR_SHARING]: 'Publishing to public...',
    [PublicSharingState.APPROVED_FOR_UNSHARING]: 'Unpublishing from public...',
};
